import formatPrice from "../utils/formatPrice";
export function orderConfirmationPage(order) {
    return {
        formatPrice: formatPrice,
        init() {
            var _a;
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "event", "purchase", {
                currency: "NOK",
                transaction_id: order.orderNumber,
                value: order.totalPaid,
                shipping: order.shippingCost,
                items: order.items.map((i) => {
                    return {
                        item_id: i.sku,
                        item_name: i.name,
                        quantity: i.quantity,
                        price: i.price,
                        currency: "NOK",
                    };
                }),
            });
        },
    };
}
